import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-741391a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Import ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download a sample ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" template ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" to see an example of the format required. ")
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Import ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Your file has been imported successfully", -1))
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Check import log ")
const _hoisted_16 = { class: "my-header" }
const _hoisted_17 = ["id"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 cursor-pointer font-weight-normal text-primary fs-16" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle" }),
  /*#__PURE__*/_createTextVNode("  Create ticket ")
], -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Read")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Unread")
const _hoisted_22 = { class: "font-bold Subject text-primary" }
const _hoisted_23 = { class: "Created fs-14" }
const _hoisted_24 = { style: {"min-height":"80px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Open ")
const _hoisted_26 = { hidden: "" }
const _hoisted_27 = {
  key: 0,
  class: "mb-2 grid-content"
}
const _hoisted_28 = { class: "mb-0 font-bold" }
const _hoisted_29 = { class: "font-normal text-muted" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Created by ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Open")
const _hoisted_32 = { class: "mb-3 ConversationItem is-seller" }
const _hoisted_33 = { class: "Top" }
const _hoisted_34 = { class: "font-bold Subject text-primary" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-1 Separator" }, "-", -1))
const _hoisted_36 = { class: "CreatedTime fs-14 text-muted" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "my-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Attachments:", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "dialog-footer" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_43 = { class: "my-header" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 cursor-pointer font-weight-normal text-primary fs-16" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }),
  /*#__PURE__*/_createTextVNode("  Back ")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 font-bold cursor-pointer fs-16" }, " Create ticket ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ticket infomation")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Attachments")
], -1))
const _hoisted_48 = { class: "dialog-footer" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_51 = {
  key: 0,
  class: "warning custom-block"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "custom-block-title" }, "WARNING", -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Topup ")
const _hoisted_54 = { class: "flex items-center justify-between card-header" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Orders", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "More actions", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-history" }, null, -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode("  Order Import Log ")
const _hoisted_59 = {
  key: 0,
  class: "fas fa-check text-success"
}
const _hoisted_60 = {
  key: 1,
  class: "fas fa-pencil-ruler text-primary"
}
const _hoisted_61 = {
  key: 2,
  class: "fas fa-times text-error"
}
const _hoisted_62 = {
  key: 0,
  class: "fas fa-check text-success"
}
const _hoisted_63 = {
  key: 1,
  class: "fas fa-times text-error"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-primary" }, "Current", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-primary" }, "Unfulfilled", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-warning" }, "Hold", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-warning" }, "InReview", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-error" }, "Rejected", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-error" }, "Cancel", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Approved", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "InTransit", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "InProduction", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Partially Fulfilled", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item text-success" }, "Fulfilled", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1))
const _hoisted_76 = { class: "flex items-center justify-between card-header" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Actions", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pause-circle" }, null, -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode("  Hold orders ")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play-circle" }, null, -1))
const _hoisted_81 = /*#__PURE__*/_createTextVNode("  Unhold orders ")
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_83 = /*#__PURE__*/_createTextVNode("  Cancel orders ")
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-double" }, null, -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode("  Verify address ")
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dolly-flatbed" }, null, -1))
const _hoisted_87 = /*#__PURE__*/_createTextVNode("  Mark tracked to store ")
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-marker" }, null, -1))
const _hoisted_89 = /*#__PURE__*/_createTextVNode("  Request design service ")
const _hoisted_90 = { key: 1 }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Display count by status ")
const _hoisted_92 = { class: "font-bold" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant:", -1))
const _hoisted_97 = { key: 1 }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Code:", -1))
const _hoisted_99 = { key: 2 }
const _hoisted_100 = { key: 3 }
const _hoisted_101 = { key: 4 }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SKU:", -1))
const _hoisted_103 = { key: 5 }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString('Custom: '), -1))
const _hoisted_105 = ["onClick"]
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tracking:", -1))
const _hoisted_108 = { key: 1 }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Custom Texts:")
], -1))
const _hoisted_111 = { class: "ml-2" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = {
  key: 0,
  class: "ml-3"
}
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" Fulfillment Warning ")
const _hoisted_115 = { style: {"font-size":"0.75rem"} }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Created:", -1))
const _hoisted_117 = { key: 0 }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Order date:", -1))
const _hoisted_119 = { key: 1 }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Approved:", -1))
const _hoisted_121 = { key: 0 }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Request:", -1))
const _hoisted_123 = {
  key: 2,
  style: {"font-size":"1.25rem"}
}
const _hoisted_124 = { key: 0 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-minus text-info",
  title: "Not need artworks"
}, null, -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { key: 1 }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-check text-success",
  title: "All order items have artworks"
}, null, -1))
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = { key: 2 }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times text-error",
  title: "Has at least order items haven't artworks"
}, null, -1))
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = { key: 3 }
const _hoisted_134 = {
  key: 0,
  class: "text-xs text-primary"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-ruler" }, null, -1))
const _hoisted_136 = /*#__PURE__*/_createTextVNode(" Requested ")
const _hoisted_137 = [
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = {
  key: 1,
  class: "text-xs text-success"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Approved ")
const _hoisted_141 = [
  _hoisted_139,
  _hoisted_140
]
const _hoisted_142 = {
  key: 2,
  class: "text-xs text-error"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_144 = /*#__PURE__*/_createTextVNode(" Rejected ")
const _hoisted_145 = [
  _hoisted_143,
  _hoisted_144
]
const _hoisted_146 = {
  key: 3,
  style: {"text-align":"left"}
}
const _hoisted_147 = { class: "font-bold" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Address 1: ", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Address 2: ", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "City: ", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Province - Zip: ", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Country Code: ", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1))
const _hoisted_155 = { class: "text-xs" }
const _hoisted_156 = { key: 4 }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Comment")
], -1))
const _hoisted_158 = { class: "mt-2" }
const _hoisted_159 = { key: 5 }
const _hoisted_160 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_161 = { class: "mb-3 text-base font-bold" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { size: 25 }, "Warning shipping title", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Can not process order with shipping title.", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode(" You can change the shipping title to "),
  /*#__PURE__*/_createElementVNode("b", null, "standard"),
  /*#__PURE__*/_createTextVNode(" to continue processing your order ")
], -1))
const _hoisted_165 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`If you still choose Express, please`) + " ")
const _hoisted_166 = { class: "mt-5 text-right" }
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" Contact ")
const _hoisted_168 = /*#__PURE__*/_createTextVNode(" Change ")
const _hoisted_169 = { key: 6 }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "csv", -1))
const _hoisted_171 = { key: 1 }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "API", -1))
const _hoisted_173 = {
  key: 2,
  style: {"font-style":"italic"},
  class: "text-xs"
}
const _hoisted_174 = ["title"]
const _hoisted_175 = ["title"]
const _hoisted_176 = { key: 7 }
const _hoisted_177 = ["title"]
const _hoisted_178 = { key: 8 }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-check",
  style: {"font-size":"1.25rem"}
}, null, -1))
const _hoisted_180 = { class: "mt-2 uppercase" }
const _hoisted_181 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('synced'))
const _hoisted_182 = { key: 9 }
const _hoisted_183 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pause-circle" }, null, -1))
const _hoisted_185 = /*#__PURE__*/_createTextVNode("  Hold order ")
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play-circle" }, null, -1))
const _hoisted_187 = /*#__PURE__*/_createTextVNode("  Unhold order ")
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_189 = /*#__PURE__*/_createTextVNode("  Cancel order ")
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-double" }, null, -1))
const _hoisted_191 = /*#__PURE__*/_createTextVNode("  Verify address ")
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dolly-flatbed" }, null, -1))
const _hoisted_193 = /*#__PURE__*/_createTextVNode("  Mark tracked order ")
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1))
const _hoisted_195 = /*#__PURE__*/_createTextVNode(" Request Seller ")
const _hoisted_196 = { key: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ImportHistoryDialog = _resolveComponent("ImportHistoryDialog")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_OrderImagePreview = _resolveComponent("OrderImagePreview")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_DepositDialog = _resolveComponent("DepositDialog")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_RequestSellerDialog = _resolveComponent("RequestSellerDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionImport: _ctx.showModalImport,
    onActionExport: _ctx.confirmExportOrder,
    onActionOtherButton1: _ctx.viewCatalogData,
    onActionReport: _ctx.reportOrders,
    onActionExportUnfulfilledOrders: _ctx.actionExportUnfulfilledOrders,
    onActionImportMapCode: _cache[48] || (_cache[48] = ($event: any) => (_ctx.isShowImportMapCode = true)),
    onActionImportHistory: _cache[49] || (_cache[49] = ($event: any) => (_ctx.isShowImportHistory = true)),
    loadingExport: _ctx.data.isLoadingExport,
    showImportFFM: true
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.isShowImportMapCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowImportMapCode) = $event)),
          title: "Import Map Code",
          width: "400px",
          "destroy-on-close": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowImportMapCode = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onImportMapCode,
                loading: _ctx.data.isLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_UploadFiles, {
              onOnChangeFiles: _ctx.onChangeFiles,
              multiple: false,
              accept: ".csv,.xlsx"
            }, null, 8, ["onOnChangeFiles"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.isShowImportHistory,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowImportHistory) = $event)),
          title: "History Import",
          width: "80%",
          "destroy-on-close": ""
        }, {
          default: _withCtx(() => [
            (_ctx.isShowImportHistory)
              ? (_openBlock(), _createBlock(_component_ImportHistoryDialog, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.isShowModalImport,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowModalImport) = $event)),
          title: "Import Orders",
          width: "30%",
          "destroy-on-close": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_el_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowModalImport = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmitImport,
                loading: _ctx.state.isLoadingAction
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_UploadFiles, {
                  onOnChangeFiles: _ctx.onChangeFiles,
                  multiple: false,
                  accept: ".csv"
                }, null, 8, ["onOnChangeFiles"]),
                _createElementVNode("p", null, [
                  _hoisted_5,
                  _createVNode(_component_el_link, {
                    type: "primary",
                    title: "Download template file",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDownloadTemplateOrder()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_checkbox, {
                    label: `Create product from order?`,
                    modelValue: _ctx.stateImport.createProduct,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stateImport.createProduct) = $event)),
                    title: "The system will create one product for each successfully imported item."
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 512), [
              [_directive_loading, _ctx.data.isLoading]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.importResultsDialogVisible,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.importResultsDialogVisible) = $event)),
          title: "Import success",
          width: "30%",
          "destroy-on-close": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.importResultsDialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.push({ name: 'seller.orders.import.histories' })))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createElementVNode("p", null, [
                _createElementVNode("b", null, "Success: " + _toDisplayString(_ctx.data.resImport.successNumber), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("b", null, "Error: " + _toDisplayString(_ctx.data.resImport.failedNumber), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.isShowTicketListModal,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isShowTicketListModal) = $event)),
          width: "50%",
          top: "2vh"
        }, _createSlots({
          default: _withCtx(() => [
            (!_ctx.isShowTicketDetailModal)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  gutter: 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 24,
                      class: "flex item-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.ticketParams.is_read,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ticketParams.is_read) = $event)),
                          label: "label position",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "all" }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "read" }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "unread" }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 24,
                      class: "flex item-center"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_table, {
                          data: _ctx.tickets,
                          style: {"width":"100%"},
                          onRowClick: _ctx.selectedTicket
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              property: "subject",
                              label: "",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("a", _hoisted_22, _toDisplayString(scope.row.subject), 1),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatTime(scope.row.created_date)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              fixed: "right",
                              label: "",
                              width: "120",
                              style: {"text-align":"right"}
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_el_tag, {
                                    type: "info",
                                    class: "mx-1",
                                    effect: "dark",
                                    round: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_25,
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(scope.$index), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data", "onRowClick"]), [
                          [_directive_loading, _ctx.dataTicket.isLoading]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  gutter: 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 16,
                      sm: 16,
                      md: 20,
                      lg: 22,
                      xl: 22
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dataTicket.ticket._id && _ctx.dataTicket.ticket._id !== '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.dataTicket.ticket.subject), 1),
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("b", null, _toDisplayString(_ctx.dataTicket.ticket.requester), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 8,
                      sm: 8,
                      md: 4,
                      lg: 2,
                      xl: 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: "info",
                          class: "mx-1",
                          effect: "dark",
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_el_table, {
                      data: _ctx.dataTicket.ticket.conversations,
                      border: false,
                      "row-class-name": _ctx.tableRowClassName
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          property: "subject",
                          label: "",
                          style: {"cursor":"pointer"}
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", _hoisted_34, _toDisplayString(scope.row.full_name
                          ? scope.row.full_name
                          : scope.row.email), 1),
                                _hoisted_35,
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatShortDateMonthTime(scope.row.updated_at)), 1)
                              ]),
                              _createElementVNode("div", {
                                class: "Description",
                                innerHTML: scope.row.body
                              }, null, 8, _hoisted_37)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data", "row-class-name"]), [
                      [_directive_loading, _ctx.dataTicket.isLoading || _ctx.dataTicket.isLoading2]
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      (_ctx.dataTicket.ticket.attachments?.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_40))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTicket.ticket.attachments, (item, index) => {
                        return (_openBlock(), _createElementBlock("p", { key: index }, [
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (_ctx.downloadFile(item)),
                            title: "Click to download file"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getFileNameFromUrl(item)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_el_form, {
                      model: _ctx.dataTicket.ticket,
                      ref: "ruleFormRef",
                      class: "w-full font-bold",
                      size: _ctx.formSize,
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "",
                          prop: "body_text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Editor, {
                              modelValue: _ctx.dataTicket.ticket.body_text,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataTicket.ticket.body_text) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "size"])
                  ]),
                  _: 1
                }))
          ]),
          _: 2
        }, [
          (!_ctx.isShowTicketDetailModal)
            ? {
                name: "header",
                fn: _withCtx(({ titleId, titleClass }) => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h4", {
                      id: titleId,
                      class: _normalizeClass(titleClass)
                    }, " All tickets for " + _toDisplayString(_ctx.selectdOrderTicketName), 11, _hoisted_17),
                    (_ctx.countTotalTicket === 0)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          link: "",
                          onClick: _ctx.onShowCreaticketModal
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              }
            : {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("div", { class: "my-header" }, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      link: "",
                      onClick: _ctx.backToTicketList
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", { class: "ml-4 cursor-pointer font-weight-normal text-primary fs-16" }, [
                          _createElementVNode("i", { class: "fas fa-chevron-left" }),
                          _createTextVNode("  Back ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createElementVNode("span", { class: "ml-4 font-bold cursor-pointer fs-16" }, " Detail ticket ")
                  ])
                ])
              },
          (!_ctx.isShowTicketDetailModal)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  _createElementVNode("span", _hoisted_41, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isShowTicketListModal = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ])
                ])
              }
            : {
                name: "footer",
                fn: _withCtx(() => [
                  _createElementVNode("span", { class: "dialog-footer" }, [
                    _createElementVNode("div", { class: "flex items-center justify-between" }, [
                      _createElementVNode("div", null, [
                        (_ctx.dataTicket.ticket.status !== 4)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.markTicketResolve(_ctx.ruleFormRef))),
                              loading: _ctx.dataTicket.isLoading2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Mark ticket as Resolved ")
                              ]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        (_ctx.dataTicket.ticket.status !== 4)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addComment(_ctx.ruleFormRef))),
                              disabled: _ctx.isDisableAddContent,
                              loading: _ctx.dataTicket.isLoading
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", { class: "fas fa-comments" }),
                                _createTextVNode("   Add Comment ")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"]))
                          : _createCommentVNode("", true),
                        (_ctx.dataTicket.ticket.status === 4)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "info",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addComment(_ctx.ruleFormRef))),
                              disabled: _ctx.isDisableAddContent,
                              loading: _ctx.dataTicket.isLoading
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Re-Open ")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              }
        ]), 1032, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.isAddTicketModal,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.isAddTicketModal) = $event)),
          width: "55%"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                onClick: _ctx.onCloseCreaticketModal
              }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              }, 8, ["onClick"]),
              _hoisted_45
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_48, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.resetForm(_ctx.ruleFormRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _ctx.ticket.form,
              ref: "ruleFormRef",
              class: "font-bold",
              size: _ctx.formSize,
              "status-icon": "",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          header: _withCtx(() => [
                            _hoisted_46
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "Order number",
                              prop: "orders",
                              rules: {
                    required: true,
                    message: 'orders can not be null',
                    trigger: 'change',
                  }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ticket.form.orders,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ticket.form.orders) = $event)),
                                  class: "w-full",
                                  placeholder: "Choose orders",
                                  disabled: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.orders, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item._id,
                                        label: item.orderName,
                                        value: item._id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Category*",
                              prop: "category",
                              rules: {
                    required: true,
                    message: 'category can not be null',
                    trigger: 'change',
                  }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ticket.form.category,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.ticket.form.category) = $event)),
                                  placeholder: "Select category",
                                  class: "w-full"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.title,
                                        label: item.tooltip,
                                        value: item.title
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (
                    _ctx.ticket.form.category !== '' &&
                    _ctx.ticket.form.category !== 'Other'
                  )
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "Sub-category*",
                                  prop: "subcategory",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.ticket.form.subcategory,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.ticket.form.subcategory) = $event)),
                                      placeholder: "Select sub category",
                                      class: "w-full"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategory, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.title,
                                            label: item.title,
                                            value: item.title
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form_item, {
                              label: "Prefer solution *",
                              prop: "prefer_solution",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ticket.form.prefer_solution,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.ticket.form.prefer_solution) = $event)),
                                  placeholder: "Select prefersolution",
                                  class: "w-full"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preferSolution, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.key,
                                        label: item.value,
                                        value: item.key
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Descriptions",
                              prop: "description",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.ticket.form.description,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.ticket.form.description) = $event)),
                                  class: "w-full",
                                  type: "textarea"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 12,
                      class: "pl-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          header: _withCtx(() => [
                            _hoisted_47
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_UploadFiles, {
                              onOnChangeFiles: _ctx.onChangeAttachmentUpload,
                              multiple: false,
                              accept: ".jpg,.png"
                            }, null, 8, ["onOnChangeFiles"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "size"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          (_ctx.data.notificationOrder?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("p", null, _toDisplayString(_ctx.data.notificationOrder[0].content), 1),
                _createVNode(_component_el_button, {
                  class: "mt-3 mb-3",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openDepositDialog(_ctx.data.notificationOrder[0].data?.amount))),
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_53
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, {
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.push({ name: 'seller.orders.import.histories' })))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_57,
                            _hoisted_58
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _hoisted_56,
                        _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_arrow_down)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "flex item-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_table, {
                onOnFilterCallback: _ctx.onFilterCallback,
                placeholder: "Search",
                title: "Search by Order name, Full name, Email, Phone, Address1"
              }, null, 8, ["onOnFilterCallback"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.status,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.params.status) = $event)),
                placeholder: "FFM Status",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusListSeller, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      placeholder: "FFM Status",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: _ctx.getOrderStatusColor(item.value),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                clearable: "",
                modelValue: _ctx.params.source,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.params.source) = $event)),
                placeholder: "Source"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'CSV', value: 'csv' },
              { label: 'API', value: 'API' },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      placeholder: "Source",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: "info",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                clearable: "",
                modelValue: _ctx.params.addressValid,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.params.addressValid) = $event)),
                placeholder: "Address"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Invalid', value: 0 },
              { label: 'Valid', value: 1 },
              { label: 'Verified', value: 2 },
              { label: 'Checking', value: 3 },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      placeholder: "Address",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: _ctx.getAddressStatusColor(item.value),
                          effect: "dark",
                          class: "rounded",
                          size: "small",
                          title: _ctx.addressTitleMap.get(item.value)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.addressTitleMap.get(item.value)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type", "title"])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                clearable: "",
                modelValue: _ctx.params.designStatus,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.params.designStatus) = $event)),
                placeholder: "Artwork"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Completed', value: 2 },
              { label: 'Requested', value: 1 },
              { label: 'Incomplete', value: 0 },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      placeholder: "Artwork",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        (item.value === 2)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_59))
                          : _createCommentVNode("", true),
                        (item.value === 1)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                          : _createCommentVNode("", true),
                        (item.value === 0)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                clearable: "",
                modelValue: _ctx.params.syncedTrackToStore,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.params.syncedTrackToStore) = $event)),
                placeholder: "Synced Tracking"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Synced', value: true },
              { label: 'Not Sync', value: false },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      placeholder: "Synced tracking",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        (item.value === true)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                          : _createCommentVNode("", true),
                        (item.value === false)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_63))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.store,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.params.store) = $event)),
                placeholder: "Store",
                clearable: "",
                filterable: "",
                remote: "",
                "remote-show-suffix": "",
                "remote-method": _ctx.getAllStoresSellers
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stores, (store) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: store.id,
                      label: store.appShopUrl,
                      value: store.id,
                      clearable: ""
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"]),
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.data.daterange,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.data.daterange) = $event)),
                onChange: _ctx.onChangeDate,
                type: "daterange",
                "range-separator": "~",
                "start-placeholder": "From date",
                "end-placeholder": "To date",
                shortcuts: _ctx.shortcutsDatetimePicker,
                "unlink-panels": ""
              }, null, 8, ["modelValue", "onChange", "shortcuts"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "flex mb-3 item-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.fulfillmentWarning,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.params.fulfillmentWarning) = $event)),
                placeholder: "Error reason",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Not enough cash', value: 'not_enough_cash' },
              { label: 'Not enough design', value: 'not_enough_design' },
              { label: 'Not found catalog', value: 'not_found_catalog' },
              { label: 'Area can not shipping', value: 'not_shipping_country' },
              {
                label: 'Base-cost or shipping not found',
                value: 'bc_or_shipping_zero',
              },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.requestSellerReasonCode,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.params.requestSellerReasonCode) = $event)),
                placeholder: "Request seller",
                filterable: "",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option_group, { label: "Requested" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RequestSeller.REASONS, (reason) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${_ctx.RequestSellerStatusEnum.requested}-${reason.value}`,
                          label: reason.label,
                          value: `${_ctx.RequestSellerStatusEnum.requested}-${reason.value}`
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_option_group, { label: "Updated" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RequestSeller.REASONS, (reason) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `${_ctx.RequestSellerStatusEnum.updated}-${reason.value}`,
                          label: reason.label,
                          value: `${_ctx.RequestSellerStatusEnum.updated}-${reason.value}`
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isDisplayCountOrderByStatus)
        ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "mt-3 text-xs"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_descriptions, {
                    class: "margin-top",
                    title: "",
                    column: 24,
                    size: _ctx.small,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_64
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, { size: "small" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.state.total ? _ctx.state.total : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_65
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Unfulfilled
                  ? _ctx.countOrderByStatus?.Unfulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_66
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Hold ? _ctx.countOrderByStatus?.Hold : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_67
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InReview ? _ctx.countOrderByStatus?.InReview : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_68
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Rejected ? _ctx.countOrderByStatus?.Rejected : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_69
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Cancel ? _ctx.countOrderByStatus?.Cancel : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_70
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Approved ? _ctx.countOrderByStatus?.Approved : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_71
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InTransit
                  ? _ctx.countOrderByStatus?.InTransit
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_72
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.InProduction
                  ? _ctx.countOrderByStatus?.InProduction
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_73
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.PartiallyFulfilled
                  ? _ctx.countOrderByStatus?.PartiallyFulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_74
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Fulfilled
                  ? _ctx.countOrderByStatus?.Fulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.getCountOrderByStatus())),
                            type: "text",
                            size: "small",
                            title: "Refresh"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_75
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"]), [
                    [_directive_loading, _ctx.data.isLoadingCount]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_76, [
                (
              _ctx.state.multipleSelection.length !== 0 &&
              _ctx.userInfo?.userType === _ctx.UserTypes.SELLER_TEAM
            )
                  ? (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 0,
                      trigger: "click",
                      placement: "bottom-end"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, { style: {"min-width":"200px"} }, {
                          default: _withCtx(() => [
                            (
                    _ctx.checkSelectOrderForAction('hold') &&
                    _ctx.userInfo?.userType !== _ctx.UserTypes.SELLER_TEAM
                  )
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onOpenMessageWarningAction('hold')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_78,
                                    _hoisted_79
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (
                    _ctx.checkSelectOrderForAction('unhold') &&
                    _ctx.userInfo?.userType !== _ctx.UserTypes.SELLER_TEAM
                  )
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onOpenMessageWarningAction('unhold')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_80,
                                    _hoisted_81
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.checkSelectOrderForAction('cancel'))
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 2,
                                  onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onOpenMessageWarningAction('cancel')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_82,
                                    _hoisted_83
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.checkSelectOrderForAction('verify-address'))
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 3,
                                  onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onOpenMessageWarningAction('verify-address')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_84,
                                    _hoisted_85
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.checkSelectOrderForAction('synced-track-to-store'))
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 4,
                                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onOpenMessageWarningAction('synced-track-to-store')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_86,
                                    _hoisted_87
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.checkSelectOrderForAction('need-hire-design'))
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 5,
                                  onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onOpenMessageWarningAction('need-hire-design')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_88,
                                    _hoisted_89
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { type: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.state.multipleSelection.length) + " selecteds ", 1),
                            _createVNode(_component_el_divider, { direction: "vertical" }),
                            _hoisted_77,
                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_arrow_down)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_90)),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_checkbox, {
                    "v-model": _ctx.isDisplayCountOrderByStatus,
                    onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onChangeDisplayCount()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_91
                    ]),
                    _: 1
                  }, 8, ["v-model"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.state.orders,
        "element-loading-text": "Loading...",
        lazy: true,
        onSelectionChange: _ctx.handleSelectionChange,
        style: {"width":"100%"},
        stripe: "",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "40"
          }),
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items.filter(
              i => i.sku !== 'Tip'
            ), (item, iItem) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  class: "px-5 py-3",
                  gutter: 20,
                  key: iItem
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "pl-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OrderImagePreview, {
                          item: item,
                          disableEdit: true
                        }, null, 8, ["item"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_92, [
                              (item.productId)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_93, [
                                    _createVNode(_component_router_link, {
                                      to: {
                        name: 's.product-detail',
                        params: { id: item.productId },
                      },
                                      class: "text-primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.itemName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString(item.itemName), 1))
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.variantTitle)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_95, [
                                      _hoisted_96,
                                      _createTextVNode(" " + _toDisplayString(item.variantTitle), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.catalogCode)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, [
                                      _hoisted_98,
                                      _createTextVNode(" " + _toDisplayString(item.catalogCode), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.sellerAmount)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(`${_ctx.formatterDollars(item.baseCost)} x ${
                        item.quantity
                      } + ${_ctx.formatterDollars(
                        item.shippingCost
                      )} = ${_ctx.formatterDollars(item.sellerAmount)}`), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(`${_ctx.formatterDollars(item.baseCost)} x ${item.quantity}`), 1)),
                                (item.sku && item.sku != 'SKU')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_101, [
                                      _hoisted_102,
                                      _createTextVNode(" " + _toDisplayString(item.sku), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.custom)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_103, [
                                      _hoisted_104,
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.onViewDetailCustom(item.custom)),
                                        class: "text-primary",
                                        title: "Click to view detail"
                                      }, _toDisplayString(item.custom.map(item => item?.value)?.join('; ')), 9, _hoisted_105)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.trackingNumber)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_106, [
                                      _hoisted_107,
                                      _createTextVNode(" " + _toDisplayString(item.trackingNumber), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.carrier)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_108, [
                                      _hoisted_109,
                                      _createTextVNode(" " + _toDisplayString(item.carrier), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            (item.customTexts)
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 0,
                                  span: 24,
                                  class: "flex"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_110,
                                    _createElementVNode("div", _hoisted_111, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.customTexts, (customText, index) => {
                                        return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(customText.display_key) + " : " + _toDisplayString(customText.display_value), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "",
            width: "40",
            "class-name": "cellTicket"
          }, {
            default: _withCtx((scope) => [
              (scope.row && scope.row.count && scope.row.count > 0)
                ? (_openBlock(), _createBlock(_component_el_badge, {
                    key: 0,
                    value: scope.row.count
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_link, {
                        underline: false,
                        type: "primary",
                        onClick: ($event: any) => (_ctx.onShowAllTicketsForOrder(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: "20" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Message)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                : (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    underline: false,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.onShowAllTicketsForOrder(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Message)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              width: column.width,
              "min-width": column.minWidth,
              props: column.dataIndex,
              align: column.align
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Order')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'seller.orders.detail',
                    params: { id: scope.row._id },
                  },
                          class: "font-bold text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (
                    scope.row?.fulfillmentWarning ||
                    scope.row.addressValid === 0
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                              _createVNode(_component_el_popover, {
                                placement: "top-start",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_icon, { style: {"color":"red"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Warning)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, { class: "font-bold text-x" }, {
                                        default: _withCtx(() => [
                                          _hoisted_114
                                        ]),
                                        _: 1
                                      }),
                                      (scope.row?.fulfillmentWarning)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 0,
                                            class: "mt-3 font-light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getWarningContent(scope.row?.fulfillmentWarning)), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (scope.row.addressValid === 0)
                                          ? (_openBlock(), _createBlock(_component_el_row, {
                                              key: 1,
                                              class: "mt-3 font-light"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("p", null, _toDisplayString(scope.row?.errorMsg || 'Address Invalid!'), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_115, [
                        _createElementVNode("p", null, [
                          _hoisted_116,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.createdDate)), 1)
                        ]),
                        (scope.row?.source === 'API' && scope.row.createdAt)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_117, [
                              _hoisted_118,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.createdAt)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (scope.row?.approveDate)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_119, [
                              _hoisted_120,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.approveDate)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (scope.row.requestSellerStatus)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_121, [
                            _hoisted_122,
                            _createVNode(_component_el_tag, {
                              class: "mx-1",
                              type: 
                    scope.row.requestSellerStatus ===
                    _ctx.RequestSellerStatusEnum.requested
                      ? `warning`
                      : `success`
                  ,
                              size: "small",
                              title: scope.row.requestSellerComment
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.requestSellerReasonCode), 1)
                              ]),
                              _: 2
                            }, 1032, ["type", "title"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (column.dataIndex === 'invoice')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {
                path: `/s/invoices/${scope.row[column.dataIndex]?._id}`,
              },
                        class: "text-blue-600",
                        title: scope.row[column.dataIndex]?.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row[column.dataIndex]?.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"]))
                    : (column.dataIndex === 'designStatus')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          (scope.row.isDropship === true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, _hoisted_126))
                            : (scope.row[column.dataIndex] === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_127, _hoisted_129))
                              : (_openBlock(), _createElementBlock("div", _hoisted_130, _hoisted_132)),
                          (
                  scope.row.metadata && scope.row.metadata.hire_design_status
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                (
                    scope.row.metadata.hire_design_status === 'assign' ||
                    scope.row.metadata.hire_design_status === 'in_review'
                  )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_134, _hoisted_137))
                                  : (
                    scope.row.metadata.hire_design_status === 'approved'
                  )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_138, _hoisted_141))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_142, _hoisted_145))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (column.dataIndex === 'fullName')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                            _createElementVNode("p", _hoisted_147, [
                              _createTextVNode(_toDisplayString(scope.row.fullName) + " ", 1),
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_InfoFilled)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, { class: "font-bold text-x" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row.fullName), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_row, { class: "mt-3" }, {
                                        default: _withCtx(() => [
                                          _hoisted_148,
                                          _createTextVNode(" " + _toDisplayString(scope.row.address1), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (_ctx.state.order.address2)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 0,
                                            class: "mt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_149,
                                              _createTextVNode(" " + _toDisplayString(scope.row.address2), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_el_row, { class: "mt-2" }, {
                                        default: _withCtx(() => [
                                          _hoisted_150,
                                          _createTextVNode(" " + _toDisplayString(scope.row.city), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_row, { class: "mt-2" }, {
                                        default: _withCtx(() => [
                                          _hoisted_151,
                                          _createTextVNode(" " + _toDisplayString(scope.row.province) + " - " + _toDisplayString(scope.row.zipCode), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_row, { class: "mt-2" }, {
                                        default: _withCtx(() => [
                                          _hoisted_152,
                                          _createTextVNode(" " + _toDisplayString(scope.row.countryCode), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (scope.row.phone)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 1,
                                            class: "mt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _hoisted_153,
                                                _createTextVNode(" " + _toDisplayString(scope.row.phone), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (scope.row.email)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 2,
                                            class: "mt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_154,
                                              _createTextVNode(" " + _toDisplayString(scope.row.email), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("p", _hoisted_155, _toDisplayString(`(${scope.row.countryCode} - ${scope.row.province} - ${scope.row.zipCode})`), 1)
                          ]))
                        : (column.dataIndex === 'status')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                              (scope.row?.comment?.length > 0)
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    placement: "top",
                                    width: "auto",
                                    trigger: "hover"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createVNode(_component_el_tag, {
                                        type: _ctx.getOrderStatusColor(scope.row.status),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.status)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["type"])
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_157,
                                      _createElementVNode("p", _hoisted_158, _toDisplayString(scope.row.comment), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 1,
                                    type: _ctx.getOrderStatusColor(scope.row.status),
                                    size: "small",
                                    title: _ctx.statusTitleMap.get(scope.row.status)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.status)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type", "title"]))
                            ]))
                          : (column.dataIndex === 'addressValid')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                (_ctx.detectLineShipOfOrder(scope.row))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                      _createVNode(_component_el_popover, {
                                        placement: "top",
                                        width: "auto",
                                        trigger: "hover"
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("button", null, [
                                            _createVNode(_component_el_icon, {
                                              size: 25,
                                              class: "font-bold text-warning"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Warning)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_161, [
                                              _createVNode(_component_el_icon, { class: "text-warning el-icon--left" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Warning)
                                                ]),
                                                _: 1
                                              }),
                                              _hoisted_162
                                            ]),
                                            _hoisted_163,
                                            _hoisted_164,
                                            _createElementVNode("i", null, [
                                              _hoisted_165,
                                              _createElementVNode("a", {
                                                href: "#",
                                                class: "text-blue-600 underline",
                                                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onClickContactSupport()))
                                              }, _toDisplayString(`contact support`)),
                                              _createTextVNode(" " + _toDisplayString(`for instructions.`), 1)
                                            ]),
                                            _createElementVNode("p", _hoisted_166, [
                                              _createVNode(_component_el_button, {
                                                size: "small",
                                                type: "text",
                                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onClickContactSupport()))
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_167
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_el_button, {
                                                size: "small",
                                                type: "primary",
                                                onClick: ($event: any) => (_ctx.onClickWarningLineShip(scope.row))
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_168
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_tag, {
                                  type: _ctx.getAddressStatusColor(scope.row[column.dataIndex]),
                                  effect: "dark",
                                  class: "rounded",
                                  size: "small",
                                  title: _ctx.addressTitleMap.get(scope.row[column.dataIndex])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.addressTitleMap.get(scope.row[column.dataIndex])), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "title"])
                              ]))
                            : (column.dataIndex === 'source')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                  (scope.row.source === 'csv')
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 0,
                                        type: "info",
                                        size: "small",
                                        title: "Order has been imported via csv"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_170
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_171, [
                                        _createVNode(_component_el_tag, {
                                          type: "info",
                                          size: "small",
                                          title: "Order has been created via API"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_172
                                          ]),
                                          _: 1
                                        })
                                      ])),
                                  (scope.row?.store)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_173, [
                                        (scope.row.store.appShopUrl)
                                          ? (_openBlock(), _createElementBlock("p", {
                                              key: 0,
                                              title: `Subdomain: ${scope.row.store.appShopUrl}`
                                            }, _toDisplayString(scope.row.store.appShopUrl), 9, _hoisted_174))
                                          : _createCommentVNode("", true),
                                        (
                    scope.row.store.domain?.toString() !==
                    scope.row.store.appShopUrl
                  )
                                          ? (_openBlock(), _createElementBlock("p", {
                                              key: 1,
                                              title: `Domain: ${scope.row.store.domain}`
                                            }, _toDisplayString(scope.row.store.domain), 9, _hoisted_175))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (column.dataIndex === 'sellerAmount')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                    _createElementVNode("div", {
                                      title: `Fulfillment cost: ${_ctx.formatterDollars(
                  scope.row[column.dataIndex]
                )}`
                                    }, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 9, _hoisted_177)
                                  ]))
                                : (column.dataIndex === 'trackingNumber')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                      _createVNode(_component_el_popover, {
                                        placement: "top",
                                        title: "List tracking number",
                                        width: "auto",
                                        trigger: "hover"
                                      }, _createSlots({
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTrackingOfOrder(
                      scope.row
                    ), (trackingNumber, index) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                              _createElementVNode("p", _hoisted_180, [
                                                _createTextVNode(_toDisplayString(trackingNumber) + " ", 1),
                                                _createVNode(_component_el_button, {
                                                  size: "small",
                                                  circle: "",
                                                  title: "Copy to clipboard",
                                                  onClick: ($event: any) => (_ctx.copyToClipboardV2(trackingNumber))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_CopyDocument)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ])
                                            ]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, [
                                        (
                    scope.row[`items`].some(function (i) {
                      return !!i.trackingNumber
                    })
                  )
                                          ? {
                                              name: "reference",
                                              fn: _withCtx(() => [
                                                _createElementVNode("span", null, [
                                                  _createVNode(_component_el_button, {
                                                    type: "text",
                                                    class: "m-0 font-bold text-success"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_179
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            }
                                          : undefined
                                      ]), 1024),
                                      _createElementVNode("p", null, [
                                        (scope.row?.syncedTrackToStore === true)
                                          ? (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 0,
                                              class: "mx-1",
                                              effect: "dark",
                                              type: "success",
                                              size: "small",
                                              title: "Synced tracking to store"
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_181
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : (column.dataIndex === 'actions')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                        (
                  _ctx.validateOrderActionSeller(scope.row.status) &&
                  _ctx.userInfo?.userType === _ctx.UserTypes.SELLER_TEAM
                )
                                          ? (_openBlock(), _createBlock(_component_el_dropdown, {
                                              key: 0,
                                              trigger: "click"
                                            }, {
                                              dropdown: _withCtx(() => [
                                                _createVNode(_component_el_dropdown_menu, null, {
                                                  default: _withCtx(() => [
                                                    (
                        _ctx.validateHold(scope.row.status) &&
                        _ctx.userInfo?.userType !== _ctx.UserTypes.SELLER_TEAM
                      )
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.holdOrder([scope.row._id]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_184,
                                                            _hoisted_185
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (
                        _ctx.validateUnHold(scope.row.status) &&
                        _ctx.userInfo?.userType !== _ctx.UserTypes.SELLER_TEAM
                      )
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 1,
                                                          onClick: ($event: any) => (_ctx.unHoldOrder([scope.row._id]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_186,
                                                            _hoisted_187
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.validateSellerCancel(scope.row))
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 2,
                                                          onClick: ($event: any) => (_ctx.cancelOrder([scope.row._id]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_188,
                                                            _hoisted_189
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (
                        _ctx.validateVerifyAddress(scope.row.status) &&
                        scope.row?.addressValid === _ctx.ADDRESS_STATUS.US_INVALID
                      )
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 3,
                                                          onClick: ($event: any) => (_ctx.verifyAddressOrder([scope.row._id]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_190,
                                                            _hoisted_191
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (
                        _ctx.validateUpdateSyncedTrackToStore(scope.row.status) &&
                        scope.row?.syncedTrackToStore !== true
                      )
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 4,
                                                          onClick: ($event: any) => (_ctx.syncedTrackToStoreOrder([scope.row._id]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_192,
                                                            _hoisted_193
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (scope.row?.requestSellerStatus)
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 5,
                                                          onClick: ($event: any) => (_ctx.onClickRequestSeller(scope.row))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_194,
                                                            _hoisted_195
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_button, { type: "text" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_183,
                                                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_arrow_down)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["label", "width", "min-width", "props", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "onSelectionChange"]), [
        [_directive_loading, _ctx.data.isLoading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.state.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_DepositDialog, {
        ref: "depositDialog",
        currentAmount: _ctx.balance,
        seller: _ctx.sellerTeam,
        onChangeBalance: _ctx.changeBalance
      }, null, 8, ["currentAmount", "seller", "onChangeBalance"]),
      _createVNode(_component_CustomDialog, { ref: "customDialog" }, null, 512),
      _createVNode(_component_RequestSellerDialog, {
        ref: "requestSellerDialog",
        onOnAfterResquestSeller: _ctx.onAfterResquestSeller
      }, null, 8, ["onOnAfterResquestSeller"])
    ]),
    _: 1
  }, 16, ["onActionImport", "onActionExport", "onActionOtherButton1", "onActionReport", "onActionExportUnfulfilledOrders", "loadingExport"]))
}